import React from 'react';
import cn from 'classname';
import './index.less';

function Row({ row, index, isHiddenCopyCols }) {
	return (
		<tr className={cn({ 'modify-background': index % 2, 'table-register-row': true})}>
			{!isHiddenCopyCols && <td>{row.id}</td>}
			<td>{row.created_at}</td>
			{!isHiddenCopyCols && <td>{row.manager}</td>}
			<td>{row.affiliate}</td>
			{!isHiddenCopyCols && <td>{row.affiliate_id}</td>}
			<td>{row.offer}</td>
			<td>{row.country}</td>
			{
				!isHiddenCopyCols &&
				<td>
					{row.sid ? `${row.sid} ${row.sid_type ? `(${row.sid_type})` : ''} & ` : ''}  {row.campaign_id}
				</td>
			}
			{!isHiddenCopyCols && <td>{Number(row.last_amount) || ''} $</td>}
			<td>{Number(row.payout_decision)} $</td>
			{!isHiddenCopyCols && <td>{row.admin}</td>}
		</tr>
	);
}

export default Row;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/table-register/row.js